module.exports = __webpack_public_path__ + "static/Sarkis_Kozanoghli_-_Javascript_Developer-6bf82175345aa2ee5815a48ea270b23c.pdf";